import { createRouter } from "@tanstack/react-router";
// Generated by @tanstack/router-vite-plugin (see vite.config.ts)
// This file exports a typed `routeTree` assembled from files in src/routes
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  trailingSlash: "never",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
